import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Typography,
  Backdrop,
  CircularProgress,
  Stack,
  Button
} from '@material-ui/core';

import moment from 'moment';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { baseUrl } from '../../utils/constants';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { useAccountingContext } from '../../context/accounting_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'vouchernos', label: 'Voucher No', alignRight: true },
  { id: 'datalo', label: 'Journal Date #', alignRight: true },
  { id: 'detailss', label: 'Details', alignRight: false },
  { id: 'trande', label: 'Chq #/DO', alignRight: true },
  { id: 'controll', label: 'Control Acc', alignRight: true },
  { id: 'debita', label: 'Debit', alignRight: true },
  { id: 'credita', label: 'Credit', alignRight: true },
  { id: 'dd', label: 'Analysis Total', alignRight: true },
  { id: 'proc', label: 'Checked', alignRight: true },
  { id: 'rog' },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function SelectVouchers() {
  const { setRefId, clearJournals, setCurrentJournal } = useAccountingContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();
  const classes = useStyles();
  const payCycle = sessionStorage.getItem('payCycleId');

  useEffect(() => {
    getVoucherDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getVoucherDetails = async () => {
    setLoading(true);
    const cycleRefId = sessionStorage.getItem('payCycleId');
    console.log('cycleRefId', cycleRefId);
    await axios(
      `${baseUrl}/api/accounting/getVoucherDetailsWithStatus?cycleRefId=${cycleRefId}`
    ).then(
      (res) => {
        setLoading(false);
        console.log('returned GetBoucherDetails', res);
        setDataList(res.data.result);
      },
      (error) => {
        setLoading(false);
        alert(`failed here ${{ error }}`);
      }
    );
  };

  const handleLineDelete = async (e) => {
    console.log('e here', e.refId);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    await axios.post(`${baseUrl}/api/accounting/deleteJournal?refId=${e.refId}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Deleting Journal!: ${result.replyMessage}`, 'error');
        } else {
          notifyPopup(`Journal Deleted Successfully!`, 'success');
          navigate(-1);
        }
      },
      (error) => {
        notifyPopup(`Error in Deleting Journal!: ${error}`, 'error');
      }
    );
  };

  const handleView = (e) => {
    // Clear claim context
    console.log('e refId', e.row.refId);
    setRefId(e.row.refId);
    setCurrentJournal(e.row);
    openView(e.row.refId);
  };

  const openView = (e) => {
    navigate(`/accounts/journals/${e}`);
  };

  const openNew = () => {
    clearJournals();
    navigate(`/accounts/journals/${0}`);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb="10">
        <Typography component="span" variant="h6" gutterBottom>
          Process Vouchers
        </Typography>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<NoteAddIcon />}
          onClick={() => openNew()}
        >
          Add New Journal
        </Button>
      </Stack>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                // onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      refId,
                      voucherNo,
                      journalDate,
                      details,
                      chequeNo,
                      controlAcc,
                      debit,
                      credit,
                      processed,
                      controlAmount
                    } = row;
                    const isItemSelected = selected.indexOf(refId) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={refId}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="right">{voucherNo}</TableCell>
                        <TableCell align="right" component="th" scope="row" padding="none">
                          {moment(journalDate).isValid()
                            ? moment(journalDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="left">{details}</TableCell>
                        <TableCell align="right">{chequeNo}</TableCell>
                        <TableCell align="right">{controlAcc}</TableCell>
                        <TableCell align="right">{debit.toFixed(2)}</TableCell>
                        <TableCell align="right">{credit.toFixed(2)}</TableCell>
                        <TableCell align="right">{controlAmount.toFixed(2)}</TableCell>
                        <TableCell align="right">
                          {credit === controlAmount ? 'Yes' : 'No'}
                        </TableCell>
                        <TableCell align="right">
                          <IconButton onClick={() => handleView({ row })}>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell>
                        <TableCell align="right">
                          {!processed && (
                            <IconButton
                              onClick={() =>
                                setConfirmDialog({
                                  isOpen: true,
                                  title: 'Are you sure you want to Delete Entry',
                                  subTitle: "You can't undo this action",
                                  heading: 'Delete Journal',
                                  color: '#00000',
                                  onConfirm: () => {
                                    handleLineDelete({ refId });
                                  }
                                })
                              }
                            >
                              <DeleteForeverIcon sx={{ color: '#f44336' }} />
                            </IconButton>
                          )}
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
